import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export type CreateSubscriptionCheckoutSessionPayloadType = {
  plan_id: string;
  ui_mode: 'custom' | 'embedded' | 'hosted';
  return_url: string;
};

export type CreateSubscriptionCheckoutSessionResponseType = {
  client_secret: string;
};

export const createSubscriptionCheckoutSessionApi = (
  data: CreateSubscriptionCheckoutSessionPayloadType
): Promise<ApiResponseType<CreateSubscriptionCheckoutSessionResponseType>> => {
  const uri = '/billing/checkout_session/subscription/';

  return authApiService.POST(uri, data);
};
